import Icon from "@ant-design/icons";

const WaterHeaterSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M2214 5102 c-10 -11 -48 -78 -84 -150 l-64 -132 -508 0 c-363 0 -514
   -3 -532 -12 -17 -7 -30 -24 -36 -47 -14 -50 -14 -4202 0 -4252 6 -23 19 -40
   36 -47 17 -8 110 -12 289 -12 l265 0 0 -97 c0 -199 30 -273 130 -325 70 -37
   130 -37 200 0 100 52 130 126 130 325 l0 97 520 0 520 0 0 -97 c0 -199 30
   -273 130 -325 70 -37 130 -37 200 0 100 52 130 126 130 325 l0 97 265 0 c179
   0 272 4 289 12 17 7 30 24 36 47 14 49 13 4204 0 4253 -7 22 -19 39 -36 46
   -18 9 -169 12 -532 12 l-508 0 -64 132 c-36 72 -74 139 -84 150 -18 17 -43 18
   -346 18 -303 0 -328 -1 -346 -18z m639 -207 l37 -75 -330 0 -330 0 37 75 37
   75 256 0 256 0 37 -75z m1127 -300 l0 -75 -1166 0 c-859 0 -1171 -3 -1187 -11
   -29 -16 -37 -28 -37 -64 0 -36 8 -48 37 -64 16 -8 328 -11 1187 -11 l1166 0 0
   -1885 0 -1885 -1420 0 -1420 0 0 1885 0 1885 116 0 c145 0 174 12 174 75 0 63
   -29 75 -174 75 l-116 0 0 75 0 75 1420 0 1420 0 0 -75z m-2100 -4274 c0 -139
   -5 -154 -55 -167 -23 -6 -64 10 -77 30 -4 6 -8 68 -8 139 l0 127 70 0 70 0 0
   -129z m1500 0 c0 -139 -5 -154 -55 -167 -23 -6 -64 10 -77 30 -4 6 -8 68 -8
   139 l0 127 70 0 70 0 0 -129z"
      />
      <path
        d="M2462 1484 c-112 -30 -210 -120 -252 -232 -31 -81 -25 -204 12 -285
   69 -148 242 -238 398 -209 122 22 228 102 278 209 37 81 43 204 12 285 -42
   114 -140 203 -256 233 -71 18 -122 18 -192 -1z m18 -246 c0 -122 12 -162 50
   -178 24 -10 36 -10 60 0 38 16 50 56 50 178 0 50 4 92 8 92 24 0 92 -63 112
   -105 18 -37 21 -59 18 -115 -5 -87 -40 -141 -118 -182 -99 -53 -216 -23 -283
   70 -26 36 -32 54 -35 112 -3 56 0 78 18 115 20 42 88 105 112 105 4 0 8 -42 8
   -92z"
      />
    </g>
  </svg>
);

const WaterHeaterIcon = (props) => (
  <Icon component={WaterHeaterSvg} {...props} />
);

export default WaterHeaterIcon;
